export default __webpack_public_path__ + "static/media/arrow-right.f24ceecd.svg";